import React from 'react';
import fr from 'facet-rest';
import { FDSecondaryActionIconButton, FDStack, FDTitleText } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const BackToEmailStepButton = ({ resource, setAuthCollection }) => {
  return resource.withRelationship(fr.relationships.authnEmail.name, (rel) => {
    return (
      <FDStack spacing={2} alignItems={'center'}>
        <FDSecondaryActionIconButton
          icon={'arrowLeft'}
          onClick={async () => {
            const coll = await rel.link('related').get();
            setAuthCollection(coll);
          }}
          test={'back-to-login-btn'}
          label={rel.meta('title')}
        />
        <FDTitleText value={rel.meta('prompt')} color={'textSecondary'} maxLines={1} />
      </FDStack>
    );
  }, () => null);
};

BackToEmailStepButton.propTypes = {
  resource: PropTypes.object.isRequired,
};
